module.exports = __webpack_public_path__ + "static/15-d2519434a99824bbf257c31d0afd35b6.jpg";